<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Enq. For Pricing Form</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div>
              <md-layout md-gutter>
                <b-col md="3">
                  <label>
                    Shipment Type
                    <span class="error">*</span>
                  </label>

                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="shipment_typeList"
                    id="shipment_type"
                    v-model="enqPriceForm.shipment_type"
                    option-value="value"
                    option-text="text"
                    placeholder="Please Select Shipment Type"
                  ></model-list-select>
                  <span class="error" v-if="!enqPriceForm.shipment_type">
                    {{ errorList.shipment_type }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Transport Type
                    <span class="error">*</span>
                  </label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="transportTypeList"
                    id="transport_type"
                    v-model="enqPriceForm.transport_type"
                    option-value="value"
                    option-text="text"
                    placeholder="Please Select Transport Type"
                    @input="
                      getLocationData(
                        enqPriceForm.transport_type,
                        enqPriceForm.shipment_type
                      )
                    "
                  ></model-list-select>
                  <span class="error" v-if="!enqPriceForm.transport_type">
                    {{ errorList.transport_type }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Type
                    <span class="error">*</span>
                  </label>
                  <b-form-radio-group
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    v-model="enqPriceForm.typeClient"
                    :options="typeClientList"
                    class="mb-3"
                    value-field="payVal"
                    text-field="payText"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                  <span class="error" v-if="!enqPriceForm.typeClient">
                    {{ errorList.typeClient }}
                  </span>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.typeClient == 'Normal'">
                  <label>
                    Lead/Client
                    <span class="error">*</span>
                  </label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="clientLeadList"
                    id="lead_client_details"
                    v-model="enqPriceForm.lead_client_details"
                    option-value="client_name"
                    option-text="client_name"
                    placeholder="Please Select Transport Type"
                    @input="LeadCLientDetails(enqPriceForm.lead_client_details)"
                  ></model-list-select>
                  <span class="error" v-if="!enqPriceForm.lead_clinet_name">
                    {{ errorList.lead_clinet_name }}
                  </span>
                </b-col>

                <b-col md="3" v-if="enqPriceForm.typeClient == 'Open Rate'">
                  <label>
                    Open Client Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="open_client_name"
                    name="open_client_name"
                    v-model="enqPriceForm.open_client_name"
                    placeholder="Please Enter Open Client Name"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!enqPriceForm.lead_clinet_name">
                    {{ errorList.lead_clinet_name }}
                  </span>
                </b-col>

                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Sea'">
                  <label>Empty PL</label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    @input="getLocationList($event, 'All', 'IcdPOrtList')"
                    @searchchange="getLocationList($event, 'All', 'IcdPOrtList')"
                    :list="$store.getters['common/getAllPORList']"
                    v-model="enqPriceForm.fk_emptyPL_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Sea'">
                  <label>POR/Handover</label>
                  <model-list-select
                    v-if="enqPriceForm.transport_type == 'Import' || enqPriceForm.transport_type == 'CRC'"
                    :isDisabled="
                      ($sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                        enqPriceForm.enq_price_id) ||
                      enqPriceForm.shipment_type == '' ||
                      enqPriceForm.transport_type == ''
                        ? true
                        : false
                    "
                    @input="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Icd,Sea_Port_India'
                          : 'Sea_Port_NonIndia',
                        'IcdPOrtList'
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Icd,Sea_Port_India'
                          : 'Sea_Port_NonIndia',
                        'IcdPOrtList'
                      )
                    "
                    :list="enqPriceForm.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:IcdPOrtListNew"
                    v-model="enqPriceForm.fk_por_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                  ></model-list-select>

                  <model-list-select
                    v-if="enqPriceForm.transport_type == 'Export'"
                    :isDisabled="
                      ($sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                        enqPriceForm.enq_price_id) ||
                      enqPriceForm.shipment_type == '' ||
                      enqPriceForm.transport_type == ''
                        ? true
                        : false
                    "
                    :list="enqPriceForm.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_por_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                  ></model-list-select>

                  <!-- :list="$store.getters['common/getAllPORList']:" -->
                  <!-- @input="getLocationList($event, 'All', 'IcdPOrtList')"
                    @searchchange="getLocationList($event, 'All', 'IcdPOrtList')" -->
                  <!-- <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    @input="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Icd,Sea_Port_India'
                          : 'Sea_Port_NonIndia',
                        'IcdPOrtList'
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Icd,Sea_Port_India'
                          : 'Sea_Port_NonIndia',
                        'IcdPOrtList'
                      )
                    "
                    :list="
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_por_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                  ></model-list-select> -->
                </b-col>

                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Sea'">
                  <label>POL</label>
                  <model-list-select
                    v-if="enqPriceForm.transport_type == 'Export'"
                    :isDisabled="
                      ($sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                        enqPriceForm.enq_price_id) ||
                      enqPriceForm.shipment_type == '' ||
                      enqPriceForm.transport_type == ''
                        ? true
                        : false
                    "
                    :list="enqPriceForm.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_pol_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                  ></model-list-select>

                  <model-list-select
                    v-if="enqPriceForm.transport_type == 'Import' || enqPriceForm.transport_type == 'CRC'"
                    :isDisabled="
                      ($sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                        enqPriceForm.enq_price_id) ||
                      enqPriceForm.shipment_type == '' ||
                      enqPriceForm.transport_type == ''
                        ? true
                        : false
                    "
                    @input="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Sea_Port_India'
                          : 'Sea_Port_NonIndia',
                        'PortLoadList'
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Sea_Port_India'
                          : 'Sea_Port_NonIndia',
                        'PortLoadList'
                      )
                    "
                    :list="enqPriceForm.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_pol_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                  ></model-list-select>
                  <!-- PortLoadList -->

                  <!-- :list="$store.getters['common/getAllPOLList']" -->

                  <!-- @input="getLocationList($event, 'All', 'PortLoadList')"
                    @searchchange="getLocationList($event, 'All', 'PortLoadList')" -->
                  <!-- <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    @input="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Sea_Port_India'
                          : 'Sea_Port_NonIndia',
                        'PortLoadList'
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Sea_Port_India'
                          : 'Sea_Port_NonIndia',
                        'PortLoadList'
                      )
                    "
                    :list="
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_pol_id"
                    option-value="pickupId"
                    option-text="location"
                    placeholder="Select POL"
                  ></model-list-select> -->
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Sea'">
                  <label>POD</label>
                  <!-- <model-list-select
                    v-if="enqPriceForm.transport_type == 'Export'"
                    :isDisabled="
                      ($sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                        enqPriceForm.enq_price_id) ||
                      enqPriceForm.shipment_type == '' ||
                      enqPriceForm.transport_type == ''
                        ? true
                        : false
                    "
                    :list="
                      $store.getters[
                        'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                      ]
                    "
                    v-model="enqPriceForm.fk_pod_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POD"
                  ></model-list-select> -->
                  <model-list-select
                    v-if="enqPriceForm.transport_type == 'Import' || enqPriceForm.transport_type == 'CRC'"
                    :isDisabled="
                      ($sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                        enqPriceForm.enq_price_id) ||
                      enqPriceForm.shipment_type == '' ||
                      enqPriceForm.transport_type == ''
                        ? true
                        : false
                    "
                    @input="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Sea_Port_NonIndia'
                          : 'Sea_Port_India',
                        'getPortDischargeList'
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Sea_Port_NonIndia'
                          : 'Icd,Sea_Port_India',
                        'getPortDischargeList'
                      )
                    "
                    :list="enqPriceForm.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_pod_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POD"
                  ></model-list-select>
                  <!-- PortDischargeList -->
                  <model-list-select
                    v-if="enqPriceForm.transport_type == 'Export'"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    @input="getLocationList($event, 'All', 'getPortDischargeList')"
                    @searchchange="getLocationList($event, 'All', 'getPortDischargeList')"
                    :list="enqPriceForm.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_pod_id"
                    option-value="pickupId"
                    option-text="location"
                    placeholder="Select POD"
                  ></model-list-select>
                  <!-- :list="
                      getPortDischargeList.length > 0
                        ? getPortDischargeList
                        : $store.getters['common/getAllLocationDetailsFinalList']
                    " -->
                </b-col>

                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Sea'">
                  <label>FPOD</label>
                  <model-list-select
                    v-if="enqPriceForm.transport_type == 'Import' || enqPriceForm.transport_type == 'CRC'"
                    :isDisabled="
                      ($sessionsStorage.get('designation') != 'Admin' &&
                        $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                        enqPriceForm.enq_price_id) ||
                      enqPriceForm.shipment_type == '' ||
                      enqPriceForm.transport_type == ''
                        ? true
                        : false
                    "
                    @input="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Sea_Port_NonIndia'
                          : 'Icd,Sea_Port_India',
                        'finalAllPlaceData'
                      )
                    "
                    @searchchange="
                      getLocationList(
                        $event,
                        enqPriceForm.shipment_type == 'Sea' &&
                          enqPriceForm.transport_type == 'Export'
                          ? 'Sea_Port_NonIndia'
                          : 'Icd,Sea_Port_India',
                        'finalAllPlaceData'
                      )
                    "
                    :list="enqPriceForm.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_fpod_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select FPOD"
                  ></model-list-select>
                  <!-- finalAllPlaceData -->
                  <model-list-select
                    v-if="enqPriceForm.transport_type == 'Export'"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    @input="getLocationList($event, 'All', 'getPortDischargeList')"
                    @searchchange="getLocationList($event, 'All', 'getPortDischargeList')"
                    :list="enqPriceForm.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_fpod_id"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select FPOD"
                  ></model-list-select>
                  <!-- <model-list-select
                    v-if="enqPriceForm.transport_type == 'Export'"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    @input="getLocationList($event, 'All', 'finalAllPlaceData')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceData')"
                    :list="
                      enqPriceForm.transport_type == 'Export'
                        ? $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
                          ]
                        : $store.getters[
                            'enqPriceEngineDropdown/getAllEnqPriceEngineIMPFPODDDList'
                          ]
                    "
                    v-model="enqPriceForm.fk_fpod_id"
                    option-value="pickupId"
                    option-text="location"
                    placeholder="Select FPOD"
                  ></model-list-select> -->
                  <!-- :list="
                      finalAllPlaceData.length > 0
                        ? finalAllPlaceData
                        : $store.getters['common/getAllLocationDetailsFinalList']
                    " -->
                </b-col>

                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Sea'">
                  <label>Shipping Line (Prefered)</label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="enqPriceForm.fk_pre_shipping"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                  ></model-list-select>
                </b-col>

                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Air'">
                  <label>Airport of Departure (Handover)</label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    @input="getLocationList($event, 'All', 'AirIcdPOrtList')"
                    @searchchange="getLocationList($event, 'All', 'AirIcdPOrtList')"
                    :list="$store.getters['common/getAllAirPortDepartureList']"
                    v-model="enqPriceForm.fk_airportDeparture"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Airport of Departure"
                  ></model-list-select>
                </b-col>

                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Air'">
                  <label>Airport of Destination</label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    @input="getLocationList($event, 'All', 'AirPortLoadList')"
                    @searchchange="getLocationList($event, 'All', 'AirPortLoadList')"
                    :list="$store.getters['common/getAllAirPortDestinationList']"
                    v-model="enqPriceForm.fk_airportDestination"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Airport of Destination"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Air'">
                  <label>Air Line (Prefered)</label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="$store.getters['common/getAllAirLineList']"
                    v-model="enqPriceForm.fk_airline_id"
                    option-value="airlineId"
                    option-text="airlineName"
                    placeholder="Select Air Line"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Air'">
                  <label for="noOfPkg">No. of Packages</label>
                  <b-form-input
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="noOfPkg"
                    name="noOfPkg"
                    type="number"
                    v-model="enqPriceForm.noOfPkg"
                  ></b-form-input>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Air'">
                  <label for="noOfPkg">Gross Wgt(Kg)</label>
                  <b-form-input
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="noOfPkg"
                    name="noOfPkg"
                    type="number"
                    v-model="enqPriceForm.lclGrossWgt"
                  ></b-form-input>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Air'">
                  <label for="noOfPkg">Net Wt ( in KG)</label>
                  <b-form-input
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="noOfPkg"
                    name="noOfPkg"
                    type="number"
                    v-model="enqPriceForm.lclNetWgt"
                  ></b-form-input>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Air'">
                  <label for="PORlocationId">Cargo Received At</label>
                  <model-list-select
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="cargoReceivedList"
                    v-model="enqPriceForm.cargoReceived"
                    option-value="val"
                    option-text="type"
                    placeholder="Select Cargo Received"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Air'">
                  <label for="PORlocationId">Destination Delivery Mode</label>
                  <model-list-select
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="destinationDelieveryList"
                    v-model="enqPriceForm.destinationModeAir"
                    option-value="val"
                    option-text="type"
                    placeholder="Select Destination"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Sea'">
                  <label>
                    commodity Type
                    <span class="error"></span>
                  </label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="commodityTypeName"
                    id="commodity_type"
                    v-model="enqPriceForm.commodity_type"
                    option-value="commodityTypeVal"
                    option-text="commodityTypeText"
                    placeholder="Please Select commodity Type"
                  ></model-list-select>
                  <span class="error" v-if="!enqPriceForm.commodity_type">
                    {{ errorList.commodity_type }}
                  </span>
                </b-col>
                <b-col md="3" v-if="enqPriceForm.commodity_type == 'Reefer'">
                  <label>
                    Temperature Req(Degree Celsius)
                    <span class="error"></span>
                  </label>
                  <b-form-input
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="temperatureRequired"
                    name="temperatureRequired"
                    v-model="enqPriceForm.temperatureRequired"
                    placeholder="Please Enter Temperature Req(Degree Celsius)"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!enqPriceForm.temperatureRequired">
                    {{ errorList.temperatureRequired }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    commodity Name
                    <span class="error"></span>
                  </label>
                  <b-form-input
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="commodity_name"
                    name="commodity_name"
                    v-model="enqPriceForm.commodity_name"
                    placeholder="Please Enter commodity Name"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!enqPriceForm.commodity_name">
                    {{ errorList.commodity_name }}
                  </span>
                </b-col>

                <b-col md="3" v-if="enqPriceForm.shipment_type == 'Sea'">
                  <label>
                    Container Type
                    <span class="error"></span>
                  </label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="AutoContainerType"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>

                  <md-chip
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    style="margin-top: 38px"
                    md-deletable
                    v-for="(type, index) in enqPriceForm.container_type"
                    :key="index"
                    @delete="deleteContainer(type)"
                    >{{ type }}</md-chip
                  >
                  <span class="error" v-if="!enqPriceForm.container_type">
                    {{ errorList.container_type }}
                  </span>
                </b-col>

                <table class="table table-sm table-bordered mt-2">
                  <tbody style="background: white">
                    <tr v-if="CONTAINERCOUNTArr.length > 0">
                      <th scope="col" style="width: 5px">SN.</th>
                      <th scope="col" style="width: 200px">CONTAINER TYPE</th>
                      <th scope="col" style="width: 180px">CONTAINER COUNT</th>
                      <th scope="col" style="width: 5px">
                        Actions
                        <b-button @click="addContainerCount()" size="sm">
                          <i class="fa fa-plus-circle ml-1"></i>
                        </b-button>
                      </th>
                    </tr>
                    <tr v-for="(item, index) in CONTAINERCOUNTArr" :key="index">
                      <th scope="row">{{ index + 1 }}.</th>
                      <td>
                        <model-list-select
                          :disabled="enqPrice_EditFlag"
                          :list="$store.getters['common/getAllContainerTypeList']"
                          option-value="containerTypeId"
                          option-text="containerType"
                          v-model="item.cont_type"
                          placeholder="Select Container Type"
                        ></model-list-select>
                        <span class="error" v-if="item.cont_type_err ? true : false">{{
                          item.cont_type_err
                        }}</span>
                      </td>
                      <td>
                        <b-form-input
                          :disabled="enqPrice_EditFlag"
                          :formatter="capitalizeAll"
                          v-model="item.cont_count"
                          type="number"
                          placeholder="Enter Container Count"
                        ></b-form-input>
                        <span class="error" v-if="item.cont_count_err ? true : false">{{
                          item.cont_count_err
                        }}</span>
                      </td>

                      <td>
                        <b-button
                          v-if="index > 0"
                          size="sm"
                          @click="removeContainerCount(index)"
                          :disabled="enqPrice_EditFlag"
                        >
                          <i class="fa fa-minus-circle" aria-hidden="true"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-col md="3">
                  <label>
                    Cargo Weight
                    <span class="error"></span>
                  </label>
                  <b-form-input
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="cargo_weight"
                    name="cargo_weight"
                    v-model="enqPriceForm.cargo_weight"
                    placeholder="Please Enter Cargo Weight"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!enqPriceForm.cargo_weight">
                    {{ errorList.cargo_weight }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Movement by
                    <span class="error"></span>
                  </label>
                  <model-list-select
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :list="momentByList"
                    id="moment_by"
                    v-model="enqPriceForm.moment_by"
                    option-value="Val"
                    option-text="Text"
                    placeholder="Please Select Moment By"
                  ></model-list-select>
                  <span class="error" v-if="!enqPriceForm.moment_by">
                    {{ errorList.moment_by }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Transit Days
                    <span class="error"></span>
                  </label>
                  <b-form-input
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="transit_days"
                    name="transit_days"
                    v-model="enqPriceForm.transit_days"
                    placeholder="Please Enter Transit Days"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!enqPriceForm.transit_days">
                    {{ errorList.transit_days }}
                  </span>
                </b-col>
                <b-col md="12">
                  <label>
                    Remark
                    <span class="error"></span>
                  </label>
                  <b-textarea
                    :disabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                      enqPriceForm.enq_price_id
                        ? true
                        : false
                    "
                    :formatter="capitalizeAll"
                    id="remarks"
                    name="remarks"
                    type="text"
                    v-model="enqPriceForm.remarks"
                    placeholder="Please Enter Remark"
                  ></b-textarea>
                  <span class="error" v-if="!enqPriceForm.remarks">
                    {{ errorList.remarks }}
                  </span>
                </b-col>

                <hr />
              </md-layout>
            </div>
            <div>
              <b-col md="6">
                <b-button
                  v-if="
                    ($sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh') ||
                    !enqPriceForm.enq_price_id
                      ? true
                      : false
                  "
                  size="sm"
                  class="pull-right"
                  style="margin:left:5px"
                  variant="primary"
                  @click="addenqPriceForm"
                  >Save</b-button
                >
                <h6>
                  <span v-if="enqPriceForm.createdBy" class="error"
                    >Created By : {{ enqPriceForm.createdBy }}</span
                  ><span v-if="enqPriceForm.created_at" class="error">
                    Created At : {{ enqPriceForm.created_at }}</span
                  >
                </h6>

                <!-- <b-button
                  v-if="enqPriceForm.enq_price_id"
                  variant="outline-primary"
                  style="font-size: 0.675rem"
                  @click="SendLead(row2.item)"
                  id="addButtonLoader"
                  size="sm"
                  >Send</b-button
                > -->
              </b-col>
              <b-col md="3"></b-col>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vue2-editor/dist/vue2-editor.umd.min.js"></script>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("edit_enq_price_id") != undefined &&
      this.$sessionsStorage.get("edit_enq_price_id") != null &&
      this.$sessionsStorage.get("edit_enq_price_id") != ""
    ) {
      // alert(this.$sessionsStorage.get("edit_enq_price_id"))
      this.getSingleEnqPricing(this.$sessionsStorage.get("edit_enq_price_id"));
    }

    // Air Section Start
    this.$store.dispatch(
      "common/setAllAirLineList",
      JSON.stringify({
        itemCode: "AirLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllAirPortDepartureList",
      JSON.stringify({
        itemCode: "AirPortDepartureList",
      })
    );
    this.$store.dispatch(
      "common/setAllAirPortDestinationList",
      JSON.stringify({
        itemCode: "AirPortDestinationList",
      })
    );
    // Air Section End

    // Sea Section Start
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );

    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type: "Normal",
        Territory: "",
      })
    );
    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );

    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineFPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineFPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePOLDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePOLDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePORDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePORDDList",
      })
    );
    this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineCrossCountryLocationDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineCrossCountryDDList",
        })
      );

    // Import DropDown Start
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPOLDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPOLDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPFPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPFPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPORDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPORDDList",
      })
    );
    // Import DropDown End
    // this.$store.dispatch(
    //   "common/setAllLeadClientList",
    //   JSON.stringify({
    //     itemCode: "enq_price_lead_clientList",
    //   })
    // );
    // Sea Section End

    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (globalPermissionStatus("Enq. For Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/pricing/upsertEnqPrice");
      // this.getSingleEnqPricing();
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
    this.getClientLeadList();
  },
  watch: {
    AutoContainerType: {
      handler: function (newVal, oldVal) {
        this.masterCallbackContainer(newVal);
      },
      deep: true,
    },
  },
  data() {
    return {
      enqPrice_EditFlag: false,
      validateCONC: true,
      CONTAINERCOUNTArr: [
        {
          cont_type: "",
          cont_count: "",

          cont_type_err: "",
          cont_count_err: "",
        },
      ],
      getPortDischargeList: [],
      finalAllPlaceData: [],
      clientLeadList: [],
      shipment_typeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      transportTypeList: [
        {
          text: "Export",
          value: "Export",
        },
        {
          text: "Import",
          value: "Import",
        },
        {
          value: "CRC",
          text: "CROSS COUNTRY",
        },
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      AutoContainerType: {},
      enqPriceForm: {
        enq_price_id: "",
        typeClient: "Normal",
        shipment_type: "Sea",
        transport_type: "Export",
        lead_client_details: "",
        fk_client_id: "",
        fk_lead_id: "",
        lead_clinet_name: "",
        lead_clinet_type: "",
        open_client_name: "",
        fk_emptyPL_id: "",
        fk_por_id: "",
        fk_pol_id: "",
        fk_pod_id: "",
        fk_fpod_id: "",
        fk_pre_shipping: "",
        fk_airportDeparture: "",
        fk_airportDestination: "",
        fk_airline_id: "",
        commodity_type: "",
        commodity_name: "",
        temperatureRequired: "",
        remarks: "",
        noOfPkg: "",
        lclGrossWgt: "",
        lclNetWgt: "",
        cargoReceived: "",
        destinationModeAir: "",
        container_type: [],
        container_type_ids: [],
        cargo_weight: "",
        moment_by: "",
        transit_days: "",
        containertype_json: [],
        is_active: true,
        created_at: "",
        createdBy: "",
      },
      enqPriceFormError: [
        "Please Select Type Of Client",
        "Please Enter Client/Lead Name",
        "Please Select Shipment Type",
        "Please Select Transport Type",
      ],
      errorList: {
        typeClient: "",
        lead_clinet_name: "",
        shipment_type: "",
        transport_type: "",
      },
      selectDateFormat,

      AutoContainerType: {},

      isLoading: false,
      validate: false,

      ContainerError: ["Please Select Container", "Please Enter No of Container"],
      containererrorList: {
        containerTypeId: "",
        noOfContainer: "",
      },
      docURL: URL_BASE_DOC,
      typeClientList: [
        { payVal: "Normal", payText: "Lead / Client", notEnabled: false },
        { payVal: "Open Rate", payText: "General Rate", notEnabled: false },
      ],
      momentByList: [
        {
          Val: "By Rail",
          Text: "By Rail",
        },
        {
          Val: "By Road",
          Text: "By Road",
        },
      ],
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      destinationDelieveryList: [
        {
          type: "upto Airport",
          val: "1",
        },
        {
          type: "DOOR",
          val: "2",
        },
      ],
      cargoReceivedList: [
        {
          type: "Airport",
          val: "1",
        },
        {
          type: "Warehouse",
          val: "2",
        },
      ],
      IcdPOrtList: [],
      finalAllPlaceData: [],
      getPortDischargeList: [],
      PortLoadList: [],
      // IcdPOrtListNew: [],
      getPortData: [],

      EXPIcdPOrtList: [],
      IMPIcdPOrtList: [],
      EXPPortLoadList: [],
      IMPPortLoadList: [],
      EXPgetPortDischargeList: [],
      EXPfinalAllPlaceData: [],
      IMPgetPortDischargeList: [],
      IMPfinalAllPlaceData: [],
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    MultiSelect,
    CustomLoader,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {
    disbleLead() {
      return this.enqPriceForm.enq_price_id != "" ? true : false;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },
    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    allLocationListFactory() {
      return this.getAlllocationListDataFactory;
    },
    PortList() {
      return this.getPortData;
    },
  },
  methods: {
    getLocationData(transport_type, shipment_type) {
      if (shipment_type == "Sea" && transport_type == "Export") {
        this.IcdPOrtList = this.EXPIcdPOrtList;
        this.PortLoadList = this.EXPPortLoadList;
        this.getPortDischargeList = this.EXPgetPortDischargeList;
        this.finalAllPlaceData = this.EXPfinalAllPlaceData;
      } else if (shipment_type == "Sea" && transport_type == "Import") {
        this.IcdPOrtList = this.IMPIcdPOrtList;
        this.PortLoadList = this.IMPPortLoadList;
        this.getPortDischargeList = this.IMPgetPortDischargeList;
        this.finalAllPlaceData = this.IMPfinalAllPlaceData;
      }
    },
    addContainerCount() {
      let obj = {
        cont_type: "",
        cont_count: "",

        cont_type_err: "",
        cont_count_err: "",
      };
      this.CONTAINERCOUNTArr.push(obj);
    },
    removeContainerCount(index) {
      this.CONTAINERCOUNTArr.splice(index, 1);
    },
    validateCONCDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.CONTAINERCOUNTArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].cont_type == "") {
          this.CONTAINERCOUNTArr[j].cont_type_err =
            "Container Type " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].cont_type_err = "";
          validate_new = true;
        }

        if (MainARR[j].cont_count == "") {
          this.CONTAINERCOUNTArr[j].cont_count_err =
            "Container Count " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].cont_count_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validateCONC = false;
      } else {
        this.validateCONC = true;
      }
    },
    async getClientLeadList() {
      // alert("hellow")
      this.isLoading = true;
      // alert(this.finalAllPlaceData.length)
      this.clientLeadList = [];
      let payload = {
        itemCode: "enq_price_lead_clientList",
      };
      // payload = JSON.stringify(payload);
      await LeadService.getClientLeadList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.clientLeadList = data.LeadClientList;
          if (
            data.EXPLocationDetailsIcdIndiaSea.length > 0 ||
            data.IMPLocationDetailsIcdIndiaSea.length > 0
          ) {
            this.EXPIcdPOrtList = data.EXPLocationDetailsIcdIndiaSea;
            this.IMPIcdPOrtList = data.IMPLocationDetailsIcdIndiaSea;
          }

          if (
            data.EXPLocationDetailsIndiaSea.length > 0 ||
            data.IMPLocationDetailsIndiaSea.length > 0
          ) {
            this.EXPPortLoadList = data.EXPLocationDetailsIndiaSea;
            this.IMPPortLoadList = data.IMPLocationDetailsIndiaSea;
          }
          if (
            data.EXPLocationDetailsSeaPortsNotIndia.length > 0 ||
            data.IMPLocationDetailsSeaPortsNotIndia.length > 0
          ) {
            this.EXPgetPortDischargeList = data.EXPLocationDetailsSeaPortsNotIndia;
            this.EXPfinalAllPlaceData = data.EXPLocationDetailsSeaPortsNotIndia;
            this.IMPgetPortDischargeList = data.IMPLocationDetailsSeaPortsNotIndia;
            this.IMPfinalAllPlaceData = data.IMPLocationDetailsSeaPortsNotIndia;
          }
          console.log("Catch on getAllLeadClientList Error: ", data.LeadClientList);

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAllLeadClientList Error: ", error);
        });
      // this.getPortDischargeList = this.$store.getters["common/getAllPODList"];
      this.getPortDischargeList = this.$store.getters[
        "common/getAllLocationDetailsFinalList"
      ];
      this.finalAllPlaceData = this.$store.getters[
        "common/getAllLocationDetailsFinalList"
      ];

      this.isLoading = false;

      console.log("this.getPortDischargeList=>", this.getPortDischargeList);
      console.log("this.finalAllPlaceData=>", this.finalAllPlaceData);
      this.getLocationData(
        this.enqPriceForm.transport_type,
        this.enqPriceForm.shipment_type
      );
    },
    goBack() {
      window.history.go(-1);
    },
    setLeadDetails(item, enq_price_id) {
      if (enq_price_id != undefined && enq_price_id != null && enq_price_id != "") {
        let enq_price_details = item;
        console.log("enq_price_details", enq_price_details);

        if (
          this.$sessionsStorage.get("designation") == "Admin" &&
          this.$sessionsStorage.get("nameUser") == "Bhavneesh"
        ) {
          this.enqPrice_EditFlag = false;
        } else {
          this.enqPrice_EditFlag = true;
        }

        let container_type = [];
        let container_type_ids = [];
        if (
          enq_price_details.container_type != undefined &&
          enq_price_details.container_type != null &&
          enq_price_details.container_type != ""
        ) {
          container_type = enq_price_details.container_type.split(",");
          container_type_ids = enq_price_details.container_type_ids.split(",");
        }
        // alert(enq_price_details.typeClient)
        // alert(enq_price_details.transit_days);
        this.enqPriceForm.containertype_json = [];
        this.enqPriceForm = {
          enq_price_id: enq_price_details.enq_price_id,
          typeClient: enq_price_details.typeClient,
          shipment_type: enq_price_details.shipment_type,
          transport_type: enq_price_details.transport_type,
          lead_client_details: enq_price_details.lead_client_details,
          open_client_name: enq_price_details.open_client_name,
          fk_emptyPL_id: enq_price_details.fk_emptyPL_id,
          fk_por_id: enq_price_details.fk_por_id,
          fk_pol_id: enq_price_details.fk_pol_id,
          fk_pod_id: enq_price_details.fk_pod_id,
          fk_fpod_id: enq_price_details.fk_fpod_id,
          fk_pre_shipping: enq_price_details.fk_pre_shipping,
          container_type: container_type,
          container_type_ids: container_type_ids,
          fk_airportDestination: enq_price_details.fk_airportDestination,
          fk_airportDeparture: enq_price_details.fk_airportDeparture,
          fk_airline_id: enq_price_details.fk_airline_id,
          remarks: enq_price_details.remarks,
          cargo_weight: enq_price_details.cargo_weight,
          moment_by: enq_price_details.moment_by,
          transit_days: enq_price_details.transit_days,
          commodity_type: enq_price_details.commodity_type,
          commodity_name: enq_price_details.commodity_name,
          temperatureRequired: enq_price_details.temperatureRequired,

          noOfPkg: enq_price_details.noOfPkg,
          lclGrossWgt: enq_price_details.lclGrossWgt,
          lclNetWgt: enq_price_details.lclNetWgt,
          cargoReceived: enq_price_details.cargoReceived,
          destinationModeAir: enq_price_details.destinationModeAir,
          is_active: true,
          containertype_json: enq_price_details.containertype_json,
          created_at: enq_price_details.created_at,
          createdBy: enq_price_details.createdBy,
        };
        this.LeadCLientDetails(enq_price_details.lead_client_details);
        let containertype_json = JSON.parse(enq_price_details.containertype_json);
        console.log(
          "enq_price_details.containertype_json=>",
          JSON.parse(enq_price_details.containertype_json)
        );
        // console.log(
        //   "this.enq_price_details.containertype_json=>",
        //   this.enq_price_details.containertype_json
        // );
        this.CONTAINERCOUNTArr = [];
        if (containertype_json.length > 0) {
          containertype_json.forEach((val, ind) => {
            let obj = {
              cont_type: val.cont_type,
              cont_count: val.cont_count,

              cont_type_err: "",
              cont_count_err: "",
            };
            this.CONTAINERCOUNTArr.push(obj);
          });
        } else if (this.enqPriceForm.container_type_ids.length > 0) {
          this.enqPriceForm.container_type_ids.forEach((val, ind) => {
            let obj = {
              cont_type: val,
              cont_count: "",

              cont_type_err: "",
              cont_count_err: "",
            };
            this.CONTAINERCOUNTArr.push(obj);
          });
        }
      } else {
        this.enqPriceForm = {
          enq_price_id: "",
          typeClient: "Normal",
          shipment_type: "",
          transport_type: "",
          lead_client_details: "",
          fk_client_id: "",
          fk_lead_id: "",
          lead_clinet_name: "",
          lead_clinet_type: "",
          open_client_name: "",
          fk_emptyPL_id: "",
          fk_por_id: "",
          fk_pol_id: "",
          fk_pod_id: "",
          fk_fpod_id: "",
          fk_pre_shipping: "",
          fk_airportDeparture: "",
          fk_airportDestination: "",
          fk_airline_id: "",
          commodity_type: "",
          commodity_name: "",
          temperatureRequired: "",
          remarks: "",

          cargo_weight: "",
          moment_by: "",
          transit_days: "",
          noOfPkg: "",
          lclGrossWgt: "",
          lclNetWgt: "",
          cargoReceived: "",
          destinationModeAir: "",
          container_type: [],
          container_type_ids: [],
          is_active: true,
          created_at: "",
          createdBy: "",
        };
      }
      this.getLocationData(
        this.enqPriceForm.transport_type,
        this.enqPriceForm.shipment_type
      );
    },

    deleteContainer(item) {
      let i = this.enqPriceForm.container_type.indexOf(item);

      this.enqPriceForm.container_type.splice(i, 1);
      this.enqPriceForm.container_type_ids.splice(i, 1);
    },
    masterCallbackContainer(item) {
      if (this.enqPriceForm.container_type.length > 0) {
        let i = this.enqPriceForm.container_type.indexOf(item.containerType);

        if (i < 0) {
          this.enqPriceForm.container_type.push(item.containerType);
          this.enqPriceForm.container_type_ids.push(item.containerTypeId);
        }
      } else {
        this.enqPriceForm.container_type.push(item.containerType);
        this.enqPriceForm.container_type_ids.push(item.containerTypeId);
      }
      console.log(item);
      console.log(this.enqPriceForm.container_type);
      console.log(this.enqPriceForm.container_type_ids);
      this.CONTAINERCOUNTArr = [];
      if (this.enqPriceForm.container_type_ids.length > 0) {
        this.enqPriceForm.container_type_ids.forEach((val, ind) => {
          let obj = {
            cont_type: val,
            rate_validity_date: "",

            cont_type_err: "",
            cont_count_err: "",
          };
          this.CONTAINERCOUNTArr.push(obj);
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    validateEnqPricing() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.enqPriceForm[x] == "" ||
          this.enqPriceForm[x] == undefined ||
          this.enqPriceForm[x] == null
        ) {
          this.errorList[x] = this.enqPriceFormError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    validateFFContainer() {
      let validate_new = true;

      if (this.containerModal.containerTypeId == "") {
        $("#containerTypeId").focus();
        this.containerTypeIdError = "Select Container Type";
        validate_new = false;
      }
      if (this.containerModal.noOfContainer == "") {
        $("#noOfContainer").focus();
        this.noOfContainerError = "Enter No of Container";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    LeadCLientDetails(lead_client_details) {
      let ClientDetails = "";
      let ClientIDS = "";
      this.enqPriceForm.fk_client_id = "";
      this.enqPriceForm.lead_clinet_type = "";
      this.enqPriceForm.lead_clinet_name = "";
      this.enqPriceForm.fk_lead_id = "";
      console.log("lead_client_details=>", lead_client_details);
      let leadclientNewArr = lead_client_details.split(" - ");
      console.log("leadclientArr=>", leadclientNewArr);
      if (lead_client_details) {
        if (leadclientNewArr.length > 0) {
          if (leadclientNewArr[1] == "C") {
          } else if (leadclientNewArr[1] == "L") {
          }
        }
        let ClientData = this.clientLeadList.filter((x) => {
          if (lead_client_details == x.client_name) {
            // if (this.enqPriceForm.lead_client_details == x.client_id) {
            return x;
          }
        });
        if (ClientData.length > 0) {
          ClientDetails = ClientData[0].client_name;
          ClientIDS = ClientData[0].client_id;
        }
        console.log("ClientData=>", ClientData);
        let leadclientArr = ClientDetails.split(" - ");
        console.log("leadclientArr=>", leadclientArr);
        if (leadclientArr.length > 0) {
          if (leadclientArr[1] == "C") {
            this.enqPriceForm.fk_client_id = ClientIDS;
            this.enqPriceForm.lead_clinet_type = "Client";
          } else if (leadclientArr[1] == "L") {
            this.enqPriceForm.fk_lead_id = ClientIDS;
            this.enqPriceForm.lead_clinet_type = "Lead";
          }
          this.enqPriceForm.lead_clinet_name = lead_client_details;
          // this.enqPriceForm.lead_clinet_name = leadclientArr[0];
        }
      }
      console.log("this.enqPriceForm=>", this.enqPriceForm);
    },

    addenqPriceForm() {
      console.log("enqPriceForm=>", this.enqPriceForm);
      console.log("errorList=>", this.errorList);
      if (this.enqPriceForm.open_client_name) {
        this.enqPriceForm.lead_clinet_name = this.enqPriceForm.open_client_name;
      }
      this.validateEnqPricing();
      this.enqPriceForm.TypeofAdd = "EnqPricing Master Add";
      if (this.validate == false) return false;
      this.enqPriceForm.AddressArr = JSON.stringify(this.AddressArr);
      this.enqPriceForm.enq_price_details = JSON.stringify(this.multiLeadArr);
      this.CONTAINERCOUNTArr.forEach((val, ind) => {
        this.$store.getters["common/getAllContainerTypeList"].forEach((val2, ind1) => {
          if (val.cont_type === val2.containerTypeId) {
            val.cont_type_name = val2.containerType;
          }
        });
      });
      this.enqPriceForm.containertype_json = JSON.stringify(this.CONTAINERCOUNTArr);
      this.isLoading = true;

      let payload = {
        itemCode: "add_enq_price_details",
        enqPriceForm: this.enqPriceForm,
      };
      payload = JSON.stringify(payload);
      console.log("payload=>", payload);
      // return false;
      if (this.validate != false) {
        LeadService.getAllEnqPricingList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.enq_price_id != "" && data.enq_price_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
            if (data.flag == true) {
              this.$router.push({
                path: "/pricing/upsertEnqPrice",
              });
            }
          })
          .catch((error) => {
            console.log("Catch on addenqPriceForm Error: ", error);
          });
      }
    },
    SendLead(item) {
      if (item.enq_price_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "Send_Lead_Mail",
          enqPriceForm: item,
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          LeadService.getAllEnqPricingList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.enq_price_id != "" && data.enq_price_id != undefined) {
                if (data.find == 1 || data.find == 2) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                }
                if (data.flag == true) {
                  this.$router.push({
                    path: "/enqPrice/enqPriceList",
                  });
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
            })
            .catch((error) => {
              console.log("Catch on SendLead Error: ", error);
            });
        }
      }
    },

    getSingleEnqPricing(id) {
      this.isLoading = true;
      let payload = {
        itemCode: "Single_enq_price",
        enq_price_id: id,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.enqPriceForm = data.singleEnqPricing;
            this.setLeadDetails(
              data.singleEnqPricing,
              data.singleEnqPricing.enq_price_id
            );
            console.log(" Single Lead response=>", data);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },

    previousFFView() {
      window.history.go(-1);
    },

    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              this.vmodelArray = result;
              console.log("self=>", self);
              console.log("vmodelArray=>", vmodelArray);
              console.log("self[vmodelArray]=>", self[vmodelArray]);
              console.log("this.vmodelArray=>", this.vmodelArray);
            }
          }
        });
      }
    },
    getLocations() {
      const option = {
        data: this.options1,
        categoryType: "hh",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getLocationList.php`,
        data: JSON.stringify(option),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { data } = result;
          this.options1 = data.userDataList;
          this.$refs["location-modal"].show();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.quotePMargin {
  margin: 0px;
  text-align: left !important;
}
.md-direction-bottom-right {
  width: 18% !important;
}

.md-flex-xsmall-100 {
  min-width: 100%;

  flex: 0 1 100%;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// upsertEnqPrice.vue?98466384